import React, { useState } from 'react';
import { Menu, Layout, ConfigProvider } from 'antd';
import {
    DashboardOutlined,
    SettingOutlined,
    FileTextOutlined,
    CommentOutlined,
    UserOutlined,
    LogoutOutlined,
    PieChartOutlined,
    BarChartOutlined,
    CalculatorOutlined,
    PercentageOutlined,
    AimOutlined,
    UserSwitchOutlined,
} from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../app/persistedSlice';
import { RootState } from "../app/store";
import { useIsInRole, useIsInPermission } from "../hooks/Authorization/authorization";
import { AuthorizationIds, Permissions } from "../hooks/Authorization/AuthorizationIds";

const { Sider } = Layout;
const { SubMenu, Divider } = Menu;

const SideMenu: React.FC = () => {
    const tenantInfo = useSelector((state: RootState) => state.persisted?.tenantInfo);

    // Hook kosulsuz cagrilmali (rules-of-hooks); sonuc asagida JSX icinde
    // sistem sahipligi kontrolu ile birlikte kullanilir.
    const isSuperAdmin = useIsInRole([AuthorizationIds.Roles.SuperAdmin]);
    const canSeeSystemManagement = Boolean(tenantInfo?.isSystemOwner) && isSuperAdmin;
    const history = useHistory();
    const [selectedKeys, setSelectedKeys] = useState<string[]>([])
    const dispatch = useDispatch();

    const logoutClicked = () => {
        dispatch(logout())
        history.push(`/${tenantInfo?.id}/`);
    }

    const handleClick = (key: string) => {
        if (key === "logout") {
            setSelectedKeys([])
            logoutClicked()
            return
        }

        setSelectedKeys([key])
        if (key === "home") {
            history.push(`/${tenantInfo?.id}/`);
            return;
        }

        history.push(`/${tenantInfo?.id}/` + key.replaceAll("-", ""));
    };

    return (

        <Sider width={250} className="site-layout-background" style={{
            position: 'relative',
            height: 'calc(100vh - 90px)',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Menu theme='dark' mode="vertical" selectedKeys={selectedKeys}
                style={{ flex: '0 1 auto', borderRight: 0, marginTop: 10 }} onSelect={(e) => {
                    handleClick(e.key)
                }}>
                {/* <SubMenu key="home" title="Ana Sayfa" icon={<DashboardOutlined/>}>
                    <SubMenu key="dashboard-okrs" title="OKR">
                        
                        <Menu.Item key="dashboard-department-okrs">Departman OKR'ları</Menu.Item>
                        
                    </SubMenu>
                    <SubMenu key="dashboard-kpis" title="KPI">
                        <Menu.Item key="dashboard-corporate-goal-card">Kurum Hedef Kartı</Menu.Item>
                    </SubMenu>
                </SubMenu>
                */}
                <Menu.Item key="home" icon={<DashboardOutlined />}>Ana Sayfa</Menu.Item>

                {/* Onceden bu ekranlar sabit ROL kimlikleriyle (AuthorizationIds.Roles.X)
                    gizleniyordu -- roller sabit oldugu icin musteri yeni bir rol
                    olusturup ona ozel bir ekran seti veremiyordu. Artik her ekran
                    kendi YETKISIYLE (useIsInPermission) kontrol ediliyor; hangi
                    rolun hangi yetkiye sahip oldugu artik veri (Roller ve Yetkiler
                    ekrani), koda gomulu degil. Super Admin her yetkiye calisma
                    zamaninda otomatik sahip (bkz. AuthorizationProvider). */}
                {useIsInPermission([Permissions.PerfCardsAccess]) &&

                    <SubMenu key="my-performance-cards" title="Performans Kartları" icon={<DashboardOutlined />}>
                        <SubMenu key="okr-performance-cards" title="OKR" icon={<AimOutlined />}>
                            <Menu.Item key="my-performance-cards-strategic-okrs">OKR'larım</Menu.Item>
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.PerfCardsTeamOkr]) && (
                                <Menu.Item key="dashboard-my-teams-okrs">Ekibimin OKR'ları</Menu.Item>
                            )}

                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.PerfCardsAllOkr]) && (
                                <Menu.Item key="admin-performance-cards-okr">Bütün OKR Kartları</Menu.Item>
                            )}
                        </SubMenu>
                        <SubMenu key="kpi-performance-cards" title="KPI" icon={<BarChartOutlined />}>
                            <Menu.Item key="my-performance-cards-kpis">KPI’larım</Menu.Item>
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.PerfCardsTeamKpi]) && (
                                <Menu.Item key="my-teams-kpis">Ekibimin KPI’ları</Menu.Item>
                            )}

                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.PerfCardsAllKpi]) && (
                                <Menu.Item key="admin-performance-cards-kpi">Bütün KPI Kartları</Menu.Item>
                            )}
                        </SubMenu>

                        <SubMenu key="competency-performance-cards" title="Yetkinlikler" icon={<UserSwitchOutlined />}>
                            <Menu.Item key="my-competencies">Yetkinliklerim</Menu.Item>
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.PerfCardsTeamCompetency]) && (
                                <Menu.Item key="my-teams-competencies">Ekibimin Yetkinlikleri</Menu.Item>
                            )}
                        </SubMenu>
                    </SubMenu>
                }
                {useIsInPermission([Permissions.OneOnOneAccess]) &&
                    <>
                        <SubMenu key="my-dialogs" title="1-1 Görüşmelerim" icon={<UserOutlined />}>
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.OneOnOneTeam]) &&
                                <Menu.Item key="my-dialogs-team">Çalışanlarımla</Menu.Item>
                            }
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.OneOnOneManager]) &&
                                <Menu.Item key="my-dialogs-manager">Yöneticimle</Menu.Item>
                            }
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.OneOnOneMyTeams]) &&
                                <Menu.Item key="my-dialogs-my-teams">Ekibimin 1-1'leri</Menu.Item>
                            }
                        </SubMenu>
                    </>
                }
                {useIsInPermission([Permissions.FeedbackAccess]) &&
                    <>
                        <SubMenu key="my-feedbacks" title="Geribildirimlerim" icon={<CommentOutlined />}>
                            <Menu.Item key="my-feedbacks-outgoing">Verdiğim Geribildirimler</Menu.Item>
                            <Menu.Item key="my-feedbacks-incoming">Aldığım Geribildirimler</Menu.Item>
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.FeedbackTeam]) &&
                                <Menu.Item key="my-feedbacks-my-teams">Ekibimin Aldığı Geribildirimler</Menu.Item>
                            }
                        </SubMenu>
                    </>
                }
                {useIsInPermission([Permissions.EvaluationManager]) &&
                    <Menu.Item key="manager-evaluation" icon={<CalculatorOutlined />}>Yönetici
                        Değerlendirmesi</Menu.Item>
                }
                {useIsInPermission([Permissions.EvaluationCalibration]) &&
                    <Menu.Item key="calibration-evaluation" icon={<PercentageOutlined />}>Kalibrasyon
                        Değerlendirmesi</Menu.Item>
                }
                {useIsInPermission([Permissions.EvaluationMyResults]) &&
                    <Menu.Item key="my-performance-results" icon={<BarChartOutlined />}>Performans Sonuçlarım</Menu.Item>
                }
                {/* <Menu.Item key="my-performance-results-okr">OKR</Menu.Item>
                    <Menu.Item key="my-performance-results-kpi">KPI</Menu.Item>
                </SubMenu>*/}
                {useIsInPermission([Permissions.ReportsAccess]) &&
                    <Menu.Item key="reports" icon={<PieChartOutlined />}>Raporlar</Menu.Item>
                }
            </Menu>
            <div style={{
                flex: '1 1 auto',
                overflowY: 'auto',
                borderRight: 0,
                maxHeight: 'calc(100vh - 150px)',
                position: "absolute",
                bottom: 0,
                width: "100%"
            }}>
                <Menu theme='dark' mode="vertical" selectedKeys={selectedKeys} onSelect={(e) => {
                    handleClick(e.key)
                }}>
                    <Divider style={{
                        borderWidth: 0.5,
                        borderColor: "rgba(255, 255, 255, 0.65)",
                        marginRight: 10,
                        marginLeft: 10,
                        marginBottom: 10
                    }} />
                    {useIsInPermission([Permissions.AdminAccess]) &&
                        <SubMenu key="management" icon={<SettingOutlined />} title="Yönetim Paneli">
                            {/* Onceden bu alt ogelerin HICBIRINDE ayri bir kontrol
                                yoktu -- ust "Yönetim Paneli" kapisindan gecen herkes
                                hepsini goruyordu. Artik her biri kendi yetkisiyle
                                ayri ayri acilip kapanabiliyor. */}
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.AdminPeriod]) &&
                                <Menu.Item key="period-definition">Dönem Tanımlama</Menu.Item>}
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.AdminTargetAudience]) &&
                                <Menu.Item key="target-audience-definition">Hedef Kitle Tanımlama</Menu.Item>}
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.AdminScale]) &&
                                <Menu.Item key="scale-definition">Skala Tanımlama</Menu.Item>}
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.AdminPerformanceSystems]) &&
                                <Menu.Item key="performance-systems-definition">Performans Sistemleri Tanımlama</Menu.Item>}
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([
                                Permissions.AdminStrategicOkrEntry, Permissions.AdminDepartmentOkrEntry,
                                Permissions.AdminCorporateGoalCard, Permissions.AdminDepartmentGoalCard,
                                Permissions.AdminCorporateGoalResult, Permissions.AdminDepartmentGoalResult,
                                Permissions.AdminIndividualKpiCards, Permissions.AdminCompetencyEntry,
                                Permissions.AdminCompetencyRoleEntry,
                            ]) &&
                                <SubMenu key="corporate-goals-competency-entry" title="Kurum Hedefleri ve Yetkinlik Girişi">
                                    <SubMenu key="corporate-goals-okr" title="OKR">
                                        {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                                        {useIsInPermission([Permissions.AdminStrategicOkrEntry]) &&
                                            <Menu.Item key="strategic-okr-entry">Stratejik OKR Girişi</Menu.Item>}
                                        {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                                        {useIsInPermission([Permissions.AdminDepartmentOkrEntry]) &&
                                            <Menu.Item key="department-okr-entry">Departman OKR Girişi</Menu.Item>}
                                    </SubMenu>
                                    <SubMenu key="corporate-goals-kpi" title="KPI">
                                        {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                                        {useIsInPermission([Permissions.AdminCorporateGoalCard]) &&
                                            <Menu.Item key="corporate-goal-card-entry">Kurum Hedef Kartı Girişi</Menu.Item>}
                                        {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                                        {useIsInPermission([Permissions.AdminDepartmentGoalCard]) &&
                                            <Menu.Item key="department-goal-card-entry">Departman Hedef Kartı Girişi</Menu.Item>}
                                        {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                                        {useIsInPermission([Permissions.AdminCorporateGoalResult]) &&
                                            <Menu.Item key="corporate-goal-result-entry">Kurum Hedef Sonuç Girişi</Menu.Item>}
                                        {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                                        {useIsInPermission([Permissions.AdminDepartmentGoalResult]) &&
                                            <Menu.Item key="department-goal-result-entry">Departman Hedef Sonuç Girişi</Menu.Item>}
                                    </SubMenu>
                                    {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                                    {useIsInPermission([Permissions.AdminIndividualKpiCards]) &&
                                        <SubMenu key="individual-goals" title="Bireysel Hedefler">
                                            <Menu.Item key="admin-individual-kpi-cards">KPI Kartları</Menu.Item>
                                        </SubMenu>}
                                    {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                                    {useIsInPermission([Permissions.AdminCompetencyEntry, Permissions.AdminCompetencyRoleEntry]) &&
                                        <SubMenu key="compemtency" title="Yetkinlik">
                                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                                            {useIsInPermission([Permissions.AdminCompetencyEntry]) &&
                                                <Menu.Item key="competency-entry">Yetkinlik Girişi</Menu.Item>}
                                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                                            {useIsInPermission([Permissions.AdminCompetencyRoleEntry]) &&
                                                <Menu.Item key="competency-role-entry">Yetkinlik - Rol Eşleştirme</Menu.Item>}
                                        </SubMenu>}
                                </SubMenu>
                            }
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.AdminPerformanceCardsCreation]) &&
                                <Menu.Item key="performance-cards-creation">Performans Kartları</Menu.Item>}
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.AdminDashboardScreens]) &&
                                <Menu.Item key="dashboard-screens">Dashboard Ekranları</Menu.Item>}
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.AdminKpiPool]) &&
                                <Menu.Item key="kpi-pool">KPI Havuzu</Menu.Item>}
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.AdminMeetingSchedule]) &&
                                <Menu.Item key="one-on-one-meeting-schedule">Performans Takvimi Tanımlama</Menu.Item>}
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.AdminNudgingEmails]) &&
                                <Menu.Item key="nudging-emails">Dürtme Mailleri</Menu.Item>}
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.AdminRolesPermissions, Permissions.AdminUserRoleDefinitions]) &&
                                <SubMenu key="role-authority-definitions" title="Rol ve Yetki Tanımlamaları">
                                    {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                                    {useIsInPermission([Permissions.AdminRolesPermissions]) &&
                                        <Menu.Item key="system-role">Roller ve Yetkiler</Menu.Item>}
                                    {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                                    {useIsInPermission([Permissions.AdminUserRoleDefinitions]) &&
                                        <Menu.Item key="user-role">Kullanıcı Rolü</Menu.Item>}
                                </SubMenu>}
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.AdminManagerEvaluationSettings]) &&
                                <SubMenu key="evaluation-settings" title="Değerlendirmeler">
                                    <Menu.Item key="managerevaluationsettings">Yönetici Değerlendirmeleri</Menu.Item>
                                </SubMenu>}
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.AdminParameters]) &&
                                <Menu.Item key="parameters">Parametreler</Menu.Item>}
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useIsInPermission([Permissions.AdminUsers]) &&
                                <Menu.Item key="users">Kullanıcılar</Menu.Item>}
                        </SubMenu>
                    }
                    {/* Sistem Yönetimi yalnızca kurulumun SAHİBİ olan şirket
                        grubuna açıktır: bulutta CoHR'ın grubu, on-premise'te
                        kurulumda oluşturulan tek grup (CompanyGroup.IsSystemOwner).

                        Rol tek başına yetmez: yeni şirket açılırken yöneticisine
                        Süper Admin rolü de veriliyor (MCompanyService.CreateCompany),
                        yani bulutta her müşterinin yöneticisi Süper Admin. Yalnızca
                        role bakmak, bir müşterinin diğer müşterilerin şirketlerini
                        görmesi demek olurdu.

                        Sabit CoHrId'ye dönmek de olmaz; on-premise'te grup kurulumda
                        üretildiği için menü hiçbir müşteride görünmezdi.

                        Bu yalnızca görünürlüktür; asıl sınır sunucuda
                        SystemOwnerOnlyFilter ile uygulanır. */}
                    {canSeeSystemManagement &&
                        < SubMenu key="system_management" icon={<SettingOutlined />} title="Sistem Yönetimi">
                            <Menu.Item key="company_groups">Şirketler</Menu.Item>
                            <Menu.Item key="logviewer">Sistem Logları</Menu.Item>
                        </SubMenu>
                    }
                </Menu>

                <Menu theme='dark' mode="inline" selectedKeys={selectedKeys}
                    style={{ flex: '0 1 auto', borderRight: 0 }}>
                    <Menu.Item key="logout" style={{ paddingLeft: 16 }} icon={<LogoutOutlined />} onClick={() => {
                        handleClick("logout")
                    }}>
                        Çıkış
                    </Menu.Item>
                </Menu>
            </div>
        </Sider>
    );
};

export default SideMenu;
